import React, { useContext, useState } from 'react'
import { AllCommentsContext } from '../context/allComentsContext';
import toast, { Toaster } from 'react-hot-toast';
const useFormComment = () => {
  const {addComment,allComments} = useContext(AllCommentsContext);
  const [email, setEmail] = useState("");
  const [commentInfo, setCommentInfo] = useState("");
  const handleForm = async(event:React.FormEvent<HTMLFormElement>)=>{
    event.preventDefault();
    if(email==="" ||  commentInfo ===''){
      return toast.error('You need to fill all the fields');
    }
    setEmail("")
    setCommentInfo("");
    await addComment(email,commentInfo,null);
    return toast.success('Comment added');
  }
  return {
      email,setEmail,commentInfo,setCommentInfo,handleForm
  }
}

export default useFormComment